// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o6Ox","colBig":"styles_colBig__1cq7P","colSmall":"styles_colSmall__Xmyan"};